export default {
  pub: null,
  auth: null,
  isActive: false,
};
